import { gql } from "generated-graphql";

gql(`
  fragment InvoiceAuditSummary on WasteInvoiceChargeAuditSummary {
    invoiceCount
    lineCount
    calculatedLineCount
    nonCompliantLineCount
    unresolvedLineCount
    validationIssueCount
    billedAmount
    expectedBaseAmount
    totalOverages
    totalUnderages
    variance
  }
`);

gql(`
  fragment InvoiceAuditContractRate on WasteInvoiceChargeAuditRate {
    id description wasteCodes pricingKeys generatorJurisdiction scheduleType rule pricingRole
    rateAmount minimumAmount quantityIncludedInBaseRate additionalRateAmount billingUnit
    effectiveFrom effectiveThrough note
  }
`);

gql(`
  fragment InvoiceAuditIssue on WasteInvoiceChargeAuditIssue {
    key
    code
    message
    invoiceId
    invoiceLineId
    blocksRateCalculation
    rateCardEntryIds
    referencedRates { ...InvoiceAuditContractRate }
  }
`);

export const INVOICE_AUDIT_REPORT = gql(`
  query InvoiceAuditReport($tenantId: ID!, $search: String, $sort: [SortModel!], $page: Int, $pageSize: Int) {
    wasteInvoiceChargeAuditReport(tenantId: $tenantId, search: $search, sort: $sort, page: $page, pageSize: $pageSize) {
      calculatedAt
      count
      items {
        invoice { id vendorId invoiceNumber invoiceDate }
        vendorName
        totals { billedAmount calculatedLineCount unresolvedLineCount totalOverages totalUnderages variance }
        facilities
      }
    }
  }
`);

export const INVOICE_AUDIT_LINE_FRAGMENT = gql(`
  fragment InvoiceAuditLine on WasteInvoiceChargeAuditLine {

        key
        facilityName
        result
        variance
        issues { ...InvoiceAuditIssue }
        validationIssues { ...InvoiceAuditIssue }
        line {
          id invoiceId sourceLineKey kind description facilityId customerFacilityId code pricingKey
          serviceDate billingQuantity billingUnit unitPrice baseAmount billedAmount taxAmount
          wasteFeeAmount fuelFeeAmount environmentalAdjustmentFeeAmount
        }
        calculation {
          rule expectedBaseAmount explanation quantity unitRate minimumAmount amount baseCharge
          includedQuantity additionalUnitRate additionalQuantity additionalCharge quantityCharge
        }
        matchedRate { ...InvoiceAuditContractRate }

  }
`);

export const INVOICE_AUDIT_SELECTED_LINE = gql(`
  query InvoiceAuditSelectedLine($id: ID!, $facilityId: ID, $lineId: ID!) {
    wasteInvoiceChargeAuditLine(id: $id, facilityId: $facilityId, lineId: $lineId) {
      ...InvoiceAuditLine
    }
  }
`);

export const INVOICE_AUDIT_LINES = gql(`
  query InvoiceAuditLines($id: ID!, $facilityId: ID, $search: String, $sort: [SortModel!], $page: Int, $pageSize: Int) {
    wasteInvoiceChargeAuditLines(id: $id, facilityId: $facilityId, search: $search, sort: $sort, page: $page, pageSize: $pageSize) {
      vendorName
      items { ...InvoiceAuditLine }
      count
    }
  }
`);

export const INVOICE_AUDIT_REPORT_SUMMARY = gql(`
  query InvoiceAuditReportSummary($tenantId: ID!, $search: String) {
    wasteInvoiceChargeAuditReportSummary(tenantId: $tenantId, search: $search) {
      calculatedAt
      summary { ...InvoiceAuditSummary }
    }
  }
`);

export const INVOICE_AUDIT_DETAIL_SUMMARY = gql(`
  query InvoiceAuditDetailSummary($id: ID!, $facilityId: ID, $search: String) {
    wasteInvoiceChargeAuditDetailSummary(id: $id, facilityId: $facilityId, search: $search) {
      invoice { id vendorId invoiceNumber invoiceDate servicePeriodStart servicePeriodEnd sourceDocumentId }
      vendorName
      summary { ...InvoiceAuditSummary }
      validationIssues { ...InvoiceAuditIssue }
      facilityCount
    }
  }
`);
